import {NfMessage, NfMessageType} from "../NfMessage";

/**
 * Wiadomość do wszystkich komponentów w zakładce z prośbą, żeby wszystkie komponenty ponownie się zarejestrowały
 */
export class RequestComponentRefresh extends NfMessage {
    public constructor(event ?:MessageEvent<RequestComponentRefresh>) {
        super(NfMessageType.RequestComponentRefresh);
    }
    public type = NfMessageType.RequestComponentRefresh;
}
NfMessage.creationCallbacks[NfMessageType.RequestComponentRefresh] = (event) => {
    return new RequestComponentRefresh(event);
}

